import * as React from 'react';
export const brexSvg = React.forwardRef(function brexSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#212121',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M18.993 9.28c-.78 1.042-.97 1.389-1.724 1.389H6V24h4.422c.996 0 1.966-.48 2.585-1.28.81-1.067.919-1.389 1.698-1.389H26V8h-4.448c-.996 0-1.966.48-2.56 1.28Zm3.503 8.611H17.78c-1.022 0-1.966.429-2.586 1.251-.81 1.067-.97 1.388-1.723 1.388H9.478v-6.4h4.716c1.022 0 1.966-.48 2.586-1.28.81-1.042 1.022-1.359 1.754-1.359h3.962v6.4Z',
    }),
  );
});
brexSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var brex = {
  category: 'brand',
  colorable: false,
  name: 'brex',
  svg: brexSvg,
};
